import React, { useContext, useState } from 'react';
import { TabsProps } from 'antd';

import DetailsTabLayout from '@totem/components/administration/devices/CrossOrgDeviceManagement/DetailsTabLayout';
import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import DeviceExportWebSockets from '@totem/components/devices/devicesContainer/DeviceExportWebSockets';
import DeviceFilters from '@totem/components/devices/devicesContainer/DeviceFilters';
import DevicesContainer, {
  containerConfiguration,
} from '@totem/components/devices/devicesContainer/DevicesContainer';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_CROSS_ORG_PAGINATION_ENDPOINT } from '@totem/utilities/endpoints';

const styles = {
  totals: {
    fontSize: '16px',
    marginRight: '20px',
  },
  tabContainer: {
    paddingRight: '2rem',
    paddingLeft: '2rem',
  },
};

const CrossOrgDevicesPage = () => {
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const { userProfile } = useContext(UserProfileContext);

  const tabItems: TabsProps['items'] = [
    {
      key: 'details',
      label: 'Details',
      children: <DetailsTabLayout />,
    },
  ];

  return (
    <ContentLayout>
      <IBCard isCovered>
        <InputContainer
          useUrlParams
          filterConfig={containerConfiguration}
          defaultSort={{
            field: 'device.displayName',
            direction: 'ascend',
          }}
          componentKey={'dashboard.crossOrgDeviceManagement'}
        >
          <DevicesContainer
            deviceEndPoint={DEVICES_CROSS_ORG_PAGINATION_ENDPOINT}
            deviceFiltersEndPoint={`${DEVICES_CROSS_ORG_PAGINATION_ENDPOINT}/filters`}
            onRecordTotalChanged={setTotalRecords}
          >
            <DeviceFilters />
            <IBTabs
              defaultActiveKey="Report"
              tabBarExtraContent={
                <span>
                  <b style={styles.totals}>{totalRecords} Devices</b>
                  {permissions.systemAdministrator.hasPermissions(
                    userProfile,
                  ) && (
                    <IBTooltip
                      content={permissions.systemAdministrator.tooltip}
                    >
                      <DeviceExportWebSockets
                        deviceExportEndPoint={
                          DEVICES_CROSS_ORG_PAGINATION_ENDPOINT
                        }
                      />
                    </IBTooltip>
                  )}
                </span>
              }
              style={styles.tabContainer}
              items={tabItems}
            />
          </DevicesContainer>
        </InputContainer>
      </IBCard>
    </ContentLayout>
  );
};

export default CrossOrgDevicesPage;
